var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1ffX6{height:297px;width:280px;font-size:24px;line-height:272px;text-align:center;display:inline-block;vertical-align:top;font-weight:400;margin:10px 10px 0;border-radius:4px;position:relative}._2YlHD{width:200px;position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);line-height:1.5}._3ZEpT{color:#8a5a5a;background:url(" + escape(require("./bg_01.jpg")) + ") no-repeat;background-size:297px}._2r-HS{color:#8c734d;background:url(" + escape(require("./bg_02.jpg")) + ") no-repeat}._3h3LO{color:#5a738a;background:url(" + escape(require("./bg_03.jpg")) + ") no-repeat}.g2hud{display:inline-block;width:900px;vertical-align:top;-webkit-box-sizing:border-box;box-sizing:border-box;height:290px}._2a8EP{padding:10px;height:292px}.EYHOy{background:red}", ""]);

// exports
exports.locals = {
	"title": "_1ffX6",
	"titleContent": "_2YlHD",
	"bg1": "_3ZEpT",
	"bg2": "_2r-HS",
	"bg3": "_3h3LO",
	"content": "g2hud",
	"slideCard": "_2a8EP",
	"courseCard": "EYHOy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/p_tag/Column/index.css
// module id = 1260
// module chunks = 2